<template>
  <div>
    <!-- Form element that submits all the data in the form to Firebase using the submitData method -->
    <form @submit.prevent="$emit('form-submit', form, day)">
      <!-- Add form fields here, wrapped in a div with a class of field -->
      <div class="field">
        <p>Please rate your worst fatigue in the past 24 hours (0 no fatigue; 10 worst fatigue imaginable):</p>
        <Radios
          name="fatigue-level"
          :entry="existingEntry"
          @store-number="storeFatigueLevel"
          data="fatigueLevel"
          amount="11"
        />
      </div>

      <div class="field">
        <button class="button button--standard" type="submit">
          <span v-if="day.edit">Update</span>
          <span v-else>Log your fatigue</span>
        </button>
        <button
          class="button button--danger"
          v-if="day.edit"
          @click.prevent="$emit('cancel-edit', day)"
        >Cancel</button>
      </div>
    </form>
  </div>
</template>

<script>
import Radios from "@/components/Radios.vue";

export default {
  name: "Form",
  props: ["existingEntry", "day"],
  components: { Radios },
  methods: {
    storeFatigueLevel(level) {
      this.form.fatigueLevel = level;
    }
  },
  data() {
    return {
      form: {
        // Add form field data here. This data will be submitted to Firestore and
        // should match the v-model values from your form fields.
        fatigueLevel: this.existingEntry
          ? this.existingEntry.data.fatigueLevel
          : 0
      }
    };
  }
};
</script>

<style>
button {
  margin-right: 1rem;
}
</style>
